import useDebounce from 'shared/composables/debounce';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import useMe from '@/composables/me';
import { discoverTenant } from '@/composables/app-start/tenant-discovery';
import { doFindAccount } from '@/api';
import { healTarget } from '@/composables/app-start/heal';
import { isAuthenticatedRouteName, legacyRoutePrefix } from '@/router';
import { useRoute, useRouter } from 'vue-router';
import { watch } from 'vue';

export default function useRouteHealer() {
  const route = useRoute();
  const router = useRouter();
  const { reachableAccounts, lastActiveAccount } = useMe();
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const { debounce } = useDebounce({ onBeforeUnmountCancel: true });

  const isLegacyRoute = (name) => typeof name === 'string' && name.startsWith(legacyRoutePrefix);

  const resolveSlug = (activeSlug) => {
    if (!isLegacyRoute(route.name)) {
      return Promise.resolve(activeSlug?.slug);
    }
    return discoverTenant(route, {
      findAccount: doFindAccount,
      accounts: reachableAccounts.value,
      lastActiveAccount: lastActiveAccount.value,
    }).then((tenant) => tenant?.slug ?? activeSlug?.slug);
  };

  watch(
    [() => route.name, () => loggedInUserAccount.value?.activeSlug],
    ([_, activeSlug]) => {
      resolveSlug(activeSlug).then((slug) => {
        const modifiedRoute = healTarget(route, slug, isAuthenticatedRouteName);
        if (modifiedRoute) {
          debounce(() => router.replace(modifiedRoute), 100);
        }
      });
    },
  );
}
